import { signal, Signal, WritableSignal } from '@angular/core'

export const promiseToSignal = <T>(
  promise: Promise<T>,
  config:
    | { initialValue: T; onError?: (err: unknown) => void }
    | { signal: WritableSignal<T>; onError?: (err: unknown) => void },
): Signal<T> => {
  let result: WritableSignal<T> | undefined = undefined
  if ('signal' in config) {
    result = config.signal
  } else if ('initialValue' in config) {
    result = signal<T>(config.initialValue)
  } else {
    throw new Error('Invalid config provided to promiseToSignal')
  }
  promise.then((value) => result.set(value)).catch((err) => config.onError?.(err))
  return result.asReadonly()
}
